export default __webpack_public_path__ + "static/media/man_in_the_wind_9.df92855c.png";